import { SPARK_STAGES } from "@/data/mock";

export default function AdminSpark() {
  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow">// Spark Studio</div>
        <h1 className="display-lg text-silver-50 mt-2">The 11-Stage Framework</h1>
        <p className="text-silver-300 mt-3 max-w-2xl">
          Configure stage prompts, tool handlers, and scope-gating here. MVP ships with 5 active stages — the remaining 6 are preserved in the framework and activated as their surfaces come online.
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {SPARK_STAGES.map((s) => (
          <div key={s.n} className={`panel p-6 ${s.active ? "border-brand-blue/40" : ""}`}>
            <div className="flex items-center justify-between">
              <div className="font-mono text-xs text-silver-300">Stage {String(s.n).padStart(2, "0")}</div>
              {s.active ? <span className="chip">Active</span> : <span className="chip-silver">Roadmap</span>}
            </div>
            <h3 className="display-md text-silver-50 mt-3">{s.name}</h3>
            <div className="hairline my-4" />
            <div className="text-silver-300 text-xs font-mono uppercase tracking-widest">
              // prompt · tools · exit criteria
            </div>
            <button className="btn-ghost mt-4 w-full justify-center">Edit stage</button>
          </div>
        ))}
      </div>
    </div>
  );
}
